import React from 'react';
import { Flex, Stack, xcss } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';

const COMMON_SKELETON_PROPS = {
	borderRadius: 8,
	isShimmering: true,
};

export type FormDialogSkeletonProps = {
	numFormFields: number;
};

export const FormDialogSkeleton = ({ numFormFields }: FormDialogSkeletonProps) => (
	<Flex direction="column" xcss={modalSkeletonStyles}>
		<Stack space="space.050">
			<Flex direction="column" xcss={headerSkeletonStyles}>
				<Stack space="space.250">
					<Skeleton
						width="40%"
						height={24}
						{...COMMON_SKELETON_PROPS}
						testId="form-dialog-skeleton.ui.header-title"
					/>
					<Skeleton
						width="35%"
						height={16}
						{...COMMON_SKELETON_PROPS}
						testId="form-dialog-skeleton.ui.header-subtitle"
					/>
				</Stack>
			</Flex>
			{Array.from({ length: numFormFields }).map((_, idx) => (
				<Stack space="space.050" key={idx} xcss={formFieldSkeletonStyles}>
					<Skeleton
						width="30%"
						height={16}
						{...COMMON_SKELETON_PROPS}
						testId={`form-field-label-${idx}`}
					/>
					<Skeleton
						width="100%"
						height={40}
						{...COMMON_SKELETON_PROPS}
						testId={`form-field-input-${idx}`}
					/>
				</Stack>
			))}
			<Flex justifyContent="end" gap="space.050">
				<Skeleton
					width={72}
					height={32}
					{...COMMON_SKELETON_PROPS}
					testId="form-dialog-skeleton.ui.cancel-button"
				/>
				<Skeleton
					width={72}
					height={32}
					{...COMMON_SKELETON_PROPS}
					testId="form-dialog-skeleton.ui.submit-button"
				/>
			</Flex>
		</Stack>
	</Flex>
);

const modalSkeletonStyles = xcss({
	backgroundColor: 'elevation.surface.overlay',
	borderRadius: '12px',
	width: '394px',
	padding: 'space.300',
});
const headerSkeletonStyles = xcss({
	marginBottom: 'space.100',
});
const formFieldSkeletonStyles = xcss({
	marginTop: 'space.100',
	marginBottom: 'space.100',
});
